const config = {
  name: "york-nb-tennis",
  features: {
    accessCodes: true,
    moreInformation: false,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: false, // Display "Redemptions left" on promo code card
    mandatoryFields: true,
    userPhoneNumber: true,
    userName: true,
    showAdaSupport: false,
    userPostalCode: true
  },
  parkingSession: {
    // Until 12 PM
    cancelDaysBefore: 0,
    cancelTime: "12:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 9 am
    startOffsetHrs: 9,
    // Start date offset from today (0 = today) = no the same day reservations
    startOffsetDate: 0,
    // End date offset from start time
    endOffsetDate: 120
  }
}
export default config
